import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import {
  AddButton,
  EditButton,
  DeletButton,
  SaveButton,
} from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Modal, Button } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { formatDateToIST, IDS, RoleId } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import ModelVerify from "../../common/ModelVerify";
// import { Modal, Button } from "react-bootstrap";
import dayjs from "dayjs";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [uid, setUid] = useState("");
  const [searchEmail, setsearchEmail] = useState("");
  const [searchNumber, setsearchNumber] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [searchDate, setSearchDate] = useState("");
  const [searchDateTo, setSearchDateTo] = useState("");

  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedAddresses, setSelectedAddresses] = useState([]);
  const [sortOrder, setSortOrder] = useState("");
  const [showModal2, setShowModal2] = useState({
    code: 0,
    message: "",
  });

  const [loader, setLoader] = useState(false);

  const getDataAll = async () => {
    setLoader(true);

    const response = await getData(
      `/admin/members?page=${onPageChange || 1}&per_page=${
        perPage || 5
      }&user_uid=${uid || ""}&term=${search || ""}&searchEmail=${searchEmail || ""}&searchNumber=${
        searchNumber || ""
      }&from=${searchDate || ""}&to=${searchDateTo || ""}`,
    );

    if (response?.success) {
      setLoader(false);
    }
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);

    setOption(await Per_Page_Dropdown(response?.data?.total));

    // const newData = response?.data?.data;
    // if (newData) {
    //   const newIds = newData.map((d) => d?.id);
    //   setAllChecked(newIds);
    // }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange, sortOrder]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/members/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/admin/members/${recordToDeleteId}`);
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  const handleViewAddress = (addresses) => {
    setSelectedAddresses(addresses);
    setShowAddressModal(true);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
    col11: true,
    col12: true,
    col13: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const BulkUpload = async (e) => {
    try {
      const formData = new FormData();
      formData.append("file", e.target.files[0]);
      const response = await postData("/admin/members/bulk", formData, {});
      if (response?.success) {
        setShowModal({ code: response.code, message: response.message });
      } else {
        setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        setShowoff(response?.data);
      }, 1000);
      getDataAll();
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const Sample = async (e) => {
    try {
      await getDownloadDataExcel("/admin/members/sample", {}, "Customer");
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        // await DownloadExcel(
        //   // "/download-excel/download-users",
        //   `/download-excel/download-users?term=${search || ""}&mobile=${mobile || ""}&from=${from || ""}&to=${to || ""}`,
        //   "Users List"
        // );
        const fileName = `Members_List_${dayjs().format("DDMMMYYYY").toLowerCase()}`;
        await getDownloadDataExcel(
          `/admin/members?term=${search || ""}&from=${searchDate || ""}&to=${
            searchDateTo || ""
          }`,
          null,
          fileName,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const roleOptions = [
    { label: "Affiliate Users", value: "true" },
    { label: "Normal Users", value: "false" },
  ];

  const [sortBy, setSortBy] = useState("orders"); // "orders" or "price"
  const sortedData = [...(data?.data?.data || [])].sort((a, b) => {
    const totalA = a?.customer_orders?.reduce(
      (sum, detail) => sum + parseFloat(detail?.total_amount || 0),
      0,
    );

    const totalB = b?.customer_orders?.reduce(
      (sum, detail) => sum + parseFloat(detail?.total_amount || 0),
      0,
    );

    // if (sortBy === "price") {
    //   return sortOrder === "asc" ? totalA - totalB : totalB - totalA;
    // } else {
    //   // fallback: sort by order count
    //   const countA = a?.customer_orders?.length || 0;
    //   const countB = b?.customer_orders?.length || 0;
    //   return sortOrder === "asc" ? countA - countB : countB - countA;
    // }
  });

  // STATES
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);

  const [showMessageModal, setShowMessageModal] = useState(false);

  const [bulkMessage, setBulkMessage] = useState("");

  const [mediaFile, setMediaFile] = useState(null);
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB
  const [loading, setLoading] = useState(false);

  // SINGLE USER SELECT
  const handleSelectUser = (id) => {
    setSelectedUsers((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      }
      return [...prev, id];
    });
  };

  // SELECT ALL
  const handleSelectAll = (checked) => {
    setIsAllSelected(checked);
    if (!checked) {
      setSelectedUsers([]);
    }
  };

  const handleSendMessage = async () => {
    try {
      if (!bulkMessage?.trim()) {
        return;
      }
      setLoading(true);

      const finalData = new FormData();
      finalData.append("is_all", isAllSelected);
      finalData.append("message", bulkMessage);
      finalData.append("user_ids", JSON.stringify(selectedUsers));
      if (mediaFile) {
        finalData.append("media_file", mediaFile);
      }
      const response = await postData(
        `/admin/co-founders/send-bulk-message?page=${onPageChange || 1}&per_page=${
          perPage || 5
        }&affiliate_status=${"true"}&user_uid=${uid || ""}&term=${search || ""}&role_id=${RoleId.Customer || ""}&searchEmail=${searchEmail || ""}&searchNumber=${
          searchNumber || ""
        }&from=${searchDate || ""}&to=${searchDateTo || ""}`,
        finalData,
      );

      if (response?.success) {
        await setShowModal2({ code: response.code, message: response.data });
      } else {
        await setShowModal2({
          code: response?.code,
          message: response?.errors,
        });
      }
      setTimeout(() => {
        setMediaFile(null);
        setBulkMessage("");
        setShowMessageModal(0);
        setShowModal2(0);
      }, 1000);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // Delete module
  const [verifyModel, setVerifyModel] = useState(false);
  const [recordVerifyId, setRecordVerifyId] = useState(null);
  const [recordToVerifyName, setRecordToVerifyName] = useState(null);

  const showVerifyRecord = async (id, name) => {
    setVerifyModel(true);
    setRecordVerifyId(id);
    setRecordToVerifyName(name);
  };

  const handleVerifyRecord = async () => {
    setVerifyModel(false);
    if (recordVerifyId) {
      const response = await postData(
        `/admin/members/add-cofounder/${recordVerifyId}`,
        { type: "add" },
      );
      if (response?.success) {
        await setShowModal2({ code: response.code, message: response.data });
      } else {
        await setShowModal2({
          code: response?.code,
          message: response?.errors,
        });
      }
      setTimeout(() => {
        setShowMessageModal(0);
        setShowModal2(0);
      }, 1000);
      getDataAll();
      setRecordVerifyId(null);
      setRecordToVerifyName(null);
    }
  };

  const handleVerifyCancel = () => {
    setVerifyModel(false);
    setRecordVerifyId(null);
    setRecordToVerifyName(null);
  };

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Members"} link={"/admin/members"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0 p-2">
              <section className="Tabels tab-radio tab-radio mt-3">
                <div className="">
                  {/* container */}
                  <div className="row p-2">
                    {/* <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                        <div className="add me-3">
                          {isAllow.includes(IDS.Brand.Add) ? (
                            <Link
                              // to="/admin/members/add"
                              type="button"
                              className="btn btn-add pe-3"
                            >
                              <div onClick={() => handleShow()}>
                                <img
                                  src={plus}
                                  className="plus me-2 ms-0"
                                  alt=""
                                />
                                Add Brand
                              </div>
                            </Link>
                          ) : (
                            <></>
                          )}
                        </div> 
                    </div>*/}

                    <div className="border-line mt-3"></div>
                    <div className="row mt-4">
                      <div className=" col-12">
                        <div className="">
                          <div className=" top-showing-wrapper  sowing ms-3 me-2">
                            {" "}
                            <p className="show m-0">Show</p>
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((option) => (
                                <option key={option} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                            <p className="show m-0">
                              Entries{" "}
                              {`Showing ${Math.min(
                                (currentPage - 1) * perPage + 1,
                              )} to ${Math.min(
                                currentPage * perPage,
                                data?.data?.total,
                              )} of ${data?.data?.total} entries`}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className=" col-12">
                        <div className="row align-items-end mb-3">
                          <div className="col-12 mb-2">
                            <div className="row p-2">
                              <div className="col-md-3 col-sm-6 mt-2">
                                <div className="num">
                                  <label className="form-label">Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id=""
                                    value={search}
                                    placeholder="Search Customer"
                                    onChange={(e) => {
                                      setSearch(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-md-3 col-sm-6 mt-2">
                                <div className="num">
                                  <label className="form-label">Email</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id=""
                                    value={searchEmail}
                                    placeholder="Search Email"
                                    onChange={(e) => {
                                      setsearchEmail(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-md-3 col-sm-6 mt-2">
                                <div className="num">
                                  <label className="form-label">
                                    Contact Number
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id=""
                                    value={searchNumber}
                                    placeholder="Contact Number"
                                    onChange={(e) => {
                                      setsearchNumber(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-md-3 col-sm-6 mt-2">
                                <div className="num">
                                  <label className="form-label">
                                    Unique Id
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id=""
                                    value={uid}
                                    placeholder="Unique Id"
                                    onChange={(e) => {
                                      setUid(e.target.value);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-md-3 col-sm-6  mt-2">
                                <div className="num me-2">
                                  <label className="form-label">
                                    Start Date
                                  </label>
                                  <input
                                    type="date"
                                    min="0001-01-01"
                                    max="9999-12-31"
                                    className="form-control"
                                    placeholder="from"
                                    value={searchDate}
                                    onChange={(e) => {
                                      setSearchDate(e.target.value);
                                      setonPageChange(1);
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-md-3 col-sm-6 mt-2">
                                <div className="num me-2">
                                  <label className="form-label">End Date</label>
                                  <input
                                    type="date"
                                    className="form-control"
                                    min="0001-01-01"
                                    max="9999-12-31"
                                    placeholder="to"
                                    value={searchDateTo}
                                    onChange={(e) => {
                                      setSearchDateTo(e.target.value);
                                      setonPageChange(1);
                                    }}
                                  />
                                </div>
                              </div>
                              {/* <div className="col-lg-3 col-md-3 col-sm-6 mt-2">
                                <Form.Label>Users</Form.Label>
                                <Select
                                  options={roleOptions}
                                  value={sortOrder}
                                  onChange={(e) => setSortOrder(e)}
                                  placeholder="Users"
                                />
                              </div> */}
                              <div className="col-md-1 col-2 mt-2 ">
                                <div className="Search me-2">
                                  <label className="form-label">Search</label>
                                  <Button
                                    type="button"
                                    onClick={() => {
                                      setonPageChange(1);

                                      getDataAll();
                                    }}
                                    className="btn btn-search"
                                  >
                                    <img
                                      src={search1}
                                      className="search"
                                      alt=""
                                    />
                                  </Button>
                                </div>
                              </div>

                              <div className="col-md-2 col-2 mt-2">
                                <div className="Search-1">
                                  <label className="form-label">Reset</label>
                                  <div>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setSearch("");
                                        setsearchEmail("");
                                        setsearchNumber("");
                                        setSearchDate("");
                                        setSearchDateTo("");
                                        setUid("");
                                        setSortOrder(null);
                                        setReset(!reset);
                                        setSelectedUsers([]);
                                        setIsAllSelected(false);
                                      }}
                                      className="btn btn-reset"
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-3 col-sm-3 mt-2">
                                <label className="form-label">
                                  Download Excel
                                </label>
                                <div>
                                  <button
                                    className="btn btn-success "
                                    type="button"
                                    onClick={HandleDownload}
                                  >
                                    Excel
                                    <FontAwesomeIcon
                                      icon="fa-solid fa-file-lines"
                                      className="ms-2"
                                    />
                                  </button>
                                </div>
                              </div>

                              <div className="col-md-3 col-sm-5  mt-2">
                                <label className="form-label">
                                  WhatsApp Message
                                </label>
                                <br />
                                <button
                                  className="btn btn-success "
                                  type="button"
                                  disabled={
                                    !isAllSelected && !selectedUsers.length
                                  }
                                  onClick={() => setShowMessageModal(true)}
                                >
                                  Send WhatsApp Message
                                  <FontAwesomeIcon
                                    icon="fa-solid fa-comments"
                                    className="ms-2"
                                  />
                                </button>
                              </div>
                              {/* <div className="col-md-3 mt-2">
                                <label className="form-label">
                                  Download Co-founder Sample
                                </label>
                                <div>
                                  <button
                                    className="btn btn-success "
                                    type="button"
                                    onClick={Sample}
                                  >
                                    Sample
                                    <FontAwesomeIcon
                                      icon="fa-solid fa-file-lines"
                                      className="ms-2"
                                    />
                                  </button>
                                </div>
                              </div> 

                              <div className="col-md-3 mt-2">
                                <label className="form-label">
                                  Upload Co-Founders
                                </label>
                                <div>
                                  <button
                                    className="btn btn-success "
                                    onClick={() =>
                                      document
                                        .getElementById("PinCodesFile")
                                        .click()
                                    }
                                  >
                                    Bulk Upload
                                  </button>

                                  <input
                                    type="file"
                                    id="PinCodesFile"
                                    onChange={(e) => {
                                      BulkUpload(e);
                                      e.target.value = "";
                                    }}
                                    accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    style={{ display: "none" }}
                                  />
                                </div>
                              </div>*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="border-line mt-3"></div>
                  <div className="row mt-3 p-2">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive>
                        <thead>
                          <tr className="">
                            <th style={{ width: "5%" }}>
                              <Form.Check
                                type="checkbox"
                                checked={isAllSelected}
                                onChange={(e) =>
                                  handleSelectAll(e.target.checked)
                                }
                              />
                            </th>
                            {visible.col1 && (
                              <th className="sr" style={{ width: "10%" }}>
                                Sr. No.
                              </th>
                            )}
                            {visible.col13 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Refer By
                              </th>
                            )}
                            {visible.col13 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Referral Code
                              </th>
                            )}

                            {visible.col2 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Name
                              </th>
                            )}
                            {visible.col3 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Email
                              </th>
                            )}
                            {visible.col4 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Contact No
                              </th>
                            )}
                            {/*  */}
                            {visible.col6 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Unique Id
                              </th>
                            )}
                            {/* {visible.col7 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Last Login
                              </th>
                            )} */}
                            {/* {visible.col11 && (
                              <th className="sr" style={{ width: "10%" }}>
                                Order
                              </th>
                            )}
                            {visible.col5 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Total Order Price
                              </th>
                            )} */}

                            {visible.col12 && (
                              <th className="sr" style={{ width: "10%" }}>
                                Address
                              </th>
                            )}
                            {visible.col10 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Created On
                              </th>
                            )}
                            {visible.col10 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Referrals
                              </th>
                            )}
                            {visible.col8 && (
                              <th className="tax-name" style={{ width: "10%" }}>
                                Status
                              </th>
                            )}
                            {visible.col9 && (
                              <th className="active" style={{ width: "10%" }}>
                                Action
                              </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {loader ? (
                            <tr>
                              <td colSpan="9" className="text-center py-4">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            sortedData?.map((d, index) => {
                              const paginatedIndex =
                                (onPageChange - 1) * perPage + index + 1;
                              return (
                                <tr className="" key={index}>
                                  <td>
                                    <Form.Check
                                      type="checkbox"
                                      checked={
                                        isAllSelected ||
                                        selectedUsers.includes(d?.id)
                                      }
                                      onChange={() => handleSelectUser(d?.id)}
                                    />
                                  </td>
                                  {visible.col1 && <td>{paginatedIndex}.</td>}
                                  {visible.col13 && (
                                    <td>
                                      {d?.ReferredUsers?.refer?.name ||
                                        "Unknown"}
                                    </td>
                                  )}
                                  {visible.col13 && (
                                    <td>{d?.refer_code || "Unknown"}</td>
                                  )}

                                  {visible.col2 && <td>{d?.name || "-"}</td>}
                                  {visible.col3 && <td>{d?.email || "-"}</td>}
                                  {visible.col4 && (
                                    <td>{d?.contact_no || "-"}</td>
                                  )}
                                  {visible.col4 && (
                                    <td>{d?.user_uid || "-"}</td>
                                  )}
                                  {/* */}
                                  {/* {visible.col6 && (
                                  <td>
                                    {d?.image && (
                                      <img
                                        className="product-image"
                                        src={IMG_URL + d?.image}
                                        alt="Image"
                                        width="100"
                                        height="100"
                                      />
                                    )}
                                  </td>
                                )}*/}
                                  {/* {visible.col7 && (
                                  <td>
                                    {formatDateToIST(d?.updatedAt)}
                                  
                                  </td>
                                )} */}
                                  {/* {visible.col11 && (
                                  <td>
                                    {Array.isArray(d?.customer_orders)
                                      ? d.customer_orders.length
                                      : 0}
                                  </td>
                                )}
                                {visible.col5 && (
                                  <td>
                                    {Array.isArray(d?.customer_orders)
                                      ? d.customer_orders
                                        .reduce(
                                          (total, order) =>
                                            total +
                                            parseFloat(
                                              order.total_amount || 0
                                            ),
                                          0
                                        )
                                        .toFixed(2)
                                      : "0.00"}
                                  </td>
                                )} */}

                                  {visible.col12 && (
                                    <td>
                                      {d?.User_Addresses?.length > 0 ? (
                                        <Button
                                          variant="info"
                                          size="sm"
                                          onClick={() =>
                                            handleViewAddress(d?.User_Addresses)
                                          }
                                        >
                                          <FontAwesomeIcon icon={faEye} />
                                        </Button>
                                      ) : (
                                        <span>No Address</span>
                                      )}
                                    </td>
                                  )}
                                  {visible.col10 && (
                                    <td>
                                      {formatDateToIST(d?.createdAt)}

                                      {/* <div>{calculateTimeAgo(d?.createdAt)}</div>
                                    <div>{formatTimeInIST(d?.createdAt)}</div> */}
                                    </td>
                                  )}

                                  {visible.col10 && (
                                    <td>
                                      <Link to={`/members/referral/${d?.id}`}>
                                        <Button
                                          variant="info"
                                          // onClick={() => handleShow1(d?.id)}
                                          type="button"
                                          className="btn btn-primary me-1"
                                        >
                                          <FontAwesomeIcon icon="fa-solid fa-eye" />
                                        </Button>
                                      </Link>
                                    </td>
                                  )}
                                  {visible.col8 && (
                                    <td>
                                      <div className="form-check form-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          checked={d.status}
                                          disabled={!isAllow?.includes(51)}
                                          onChange={() => {
                                            ChangeStatus(d.id);
                                          }}
                                          id={`flexSwitchCheckDefault${d?.id}`}
                                        />
                                        <label
                                          className="form-check-label"
                                          style={{ pointerEvents: "none" }}
                                          htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                        >
                                          {d.status ? "Active" : "Inactive"}
                                        </label>
                                      </div>
                                    </td>
                                  )}
                                  {visible.col9 && (
                                    <td>
                                      <div className="d-flex">
                                        {isAllow.includes(IDS.Customer.List) ? (
                                          <Link to={`/members/view/${d?.id}`}>
                                            <Button
                                              // onClick={() => handleShow1(d?.id)}
                                              type="button"
                                              className="btn btn-primary me-1"
                                            >
                                              <FontAwesomeIcon icon="fa-solid fa-eye" />
                                            </Button>
                                          </Link>
                                        ) : (
                                          <></>
                                        )}
                                        {isAllow.includes(
                                          IDS.Customer.Delete,
                                        ) ? (
                                          <DeletButton
                                            showDeleteRecord={showDeleteRecord}
                                            id={d?.id}
                                            name={d?.name}
                                          />
                                        ) : (
                                          <></>
                                        )}
                                        {isAllow.includes(IDS.Customer.Edit) &&
                                        d.affiliate_status ? (
                                          <Link
                                            type="button"
                                            className="btn btn-primary me-1"
                                          >
                                            <div
                                              onClick={() =>
                                                showVerifyRecord(d?.id, d?.name)
                                              }
                                            >
                                              <img
                                                src={plus}
                                                className="plus me-2 ms-0"
                                                alt=""
                                              />
                                              Add Co-Founder
                                            </div>
                                          </Link>
                                        ) : (
                                          <div className="btn btn-primary me-1">
                                            Not Puchased the Joining Kit
                                          </div>
                                        )}
                                      </div>
                                    </td>
                                  )}
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}
      <ModalSave
        message={showModal2.message}
        showErrorModal={showModal2.code ? true : false}
      />
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModelVerify
        show={verifyModel}
        message={`Do you really want to Add ${recordToVerifyName} to Co-Founder?`}
        onConfirm={handleVerifyRecord}
        onCancel={handleVerifyCancel}
      />

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />

      <Modal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
        size="lg"
        centered
        className="userdeatailspp"
      >
        <Modal.Header closeButton>
          <Modal.Title>User Address Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedAddresses.length > 0 ? (
            selectedAddresses.map((address, index) => (
              <div key={index} className="mb-3 border p-2 rounded">
                <h5 className="mb-3">Address {index + 1}</h5>
                <div className="row">
                  <div className="col-lg-6">
                    <p>
                      <strong>Building:</strong> {address.building || "-"}
                    </p>
                  </div>
                  {/* <div className="col-lg-6">
                    <p>
                      <strong>Floor:</strong> {address.floor}
                    </p>
                  </div> */}
                  {/* <div className="col-lg-6">
                    <p>
                      <strong>Apartment:</strong> {address.apartment}
                    </p>
                  </div> */}
                  <div className="col-lg-6">
                    <p>
                      <strong>Street:</strong> {address.street || "-"}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>Landmark:</strong> {address.direction || "-"}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>Contact No:</strong> {address.contact_no || "-"}
                    </p>
                  </div>
                  {/* <div className="col-lg-6">
                    <p>
                      <strong>Latitude:</strong> {address.lat}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>Longitude:</strong> {address.long}
                    </p>
                  </div> */}
                  <div className="col-lg-6">
                    <p>
                      <strong>Country:</strong>
                      {address.Users_Address_Detail?.Country?.name || "-"}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>State:</strong>
                      {address.Users_Address_Detail?.State?.name || "-"}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>City:</strong>
                      {address.Users_Address_Detail?.City?.name || "-"}
                    </p>
                  </div>
                  <div className="col-lg-6">
                    <p>
                      <strong>Pincode:</strong>
                      {address.Users_Address_Detail?.Pincode?.name || "-"}
                    </p>
                  </div>
                  {/* <div className="col-lg-6">
                    <p>
                      <strong>Area:</strong>
                      {address.Users_Address_Detail?.Area?.name}
                    </p>
                  </div> */}
                </div>
              </div>
            ))
          ) : (
            <p>No address details available.</p>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={showMessageModal}
        onHide={() => setShowMessageModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Send WhatsApp Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Message</Form.Label>

            <Form.Control
              as="textarea"
              rows={5}
              maxLength={1000}
              placeholder="Enter message"
              value={bulkMessage}
              onChange={(e) => setBulkMessage(e.target.value)}
            />

            <div className="text-end mt-1">{bulkMessage.length}/1000</div>
          </Form.Group>

          <Form.Group>
            <Form.Label>Media (Optional)</Form.Label>

            <Form.Control
              type="file"
              accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx"
              onChange={(e) => {
                const file = e.target.files[0];

                if (!file) {
                  setMediaFile(null);
                  return;
                }

                if (file.size > MAX_FILE_SIZE) {
                  alert("File size must not exceed 5 MB.");
                  e.target.value = "";
                  setMediaFile(null);
                  return;
                }

                setMediaFile(file);
              }}
            />

            <small className="text-muted d-block mt-1">
              Maximum file size: 5 MB
            </small>

            {mediaFile && (
              <small className="text-success mt-2 d-block">
                Selected: {mediaFile.name} (
                {(mediaFile.size / (1024 * 1024)).toFixed(2)} MB)
              </small>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowMessageModal(false);
              setBulkMessage("");
            }}
          >
            Cancel
          </Button>

          <Button
            variant="success"
            disabled={loading || !bulkMessage?.trim()}
            onClick={handleSendMessage}
          >
            {loading ? "Sending..." : "Send Message"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Tables;
